import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { NativeStorage } from "@ionic-native/native-storage";
import { IEmployee, IApprover } from "../model/top.model";
import { Jobrole } from "../enums/enums";
import { ENV } from '@app/env';

@Injectable()
export class EmployeeData {
  employees: Array<IEmployee>;
  loggedInEmployeeId: string;
  jobRoles: Array<Jobrole>;
  apiUrl: string = ENV.apiUrl;

  constructor(
    public http: HttpClient,
    public storage: Storage,
    public nativeStorage: NativeStorage
  ) { }

  getEmployees(
    period: boolean,
    year?: string,
    week?: string
  ): Promise<Array<IEmployee>> {
    let employeeObject = {
      operation: "ALL",
      period: period,
      year: year,
      week: week,
    };
    return new Promise((resolve) => {
      this.http.post<IEmployee[]>(
        this.apiUrl + "employees/",
        JSON.stringify(employeeObject)
      ).subscribe((response) => {
        this.employees = response;
        resolve(response);
      }, (error) => {
        resolve(null);
      });
    });
  }

  getEmployeesBasic(): Promise<Array<IEmployee>> {
    let employeeObject = {
      operation: "ALL_BASIC"
    };
    return new Promise((resolve) => {
      this.http.post<IEmployee[]>(
        this.apiUrl + "employees/",
        JSON.stringify(employeeObject)
      ).subscribe((response) => {
        this.employees = response;
        resolve(response);
      }, (error) => {
        resolve(null);
      });
    });
  }

  createEmployee(employee: IEmployee): Promise<Array<IEmployee>> {
    employee.operation = "POST";
    return new Promise((resolve) => {
      this.http.post<IEmployee[]>(
        this.apiUrl + "employees/",
        JSON.stringify(employee)
      ).subscribe((response) => {
        employee.employee_id = response[2].employee_id;
        employee.address.address_id = response[0].address_id;
        this.employees.push(employee);
        resolve(response);
      }, (error) => {
        resolve(null);
      });
    });
  }

  getEmployee(employeeId: string): Promise<IEmployee> {
    let employeeObject = {
      operation: "GET",
      employee_id: employeeId,
    };
    return new Promise((resolve) => {
      this.http.post(
        this.apiUrl + "employees/",
        JSON.stringify(employeeObject)
      ).subscribe((response) => {
        resolve(response[0]);
      }, (error) => {
        resolve(null);
      });
    });
  }

  getApprovers(): Promise<IApprover[]> {
    let employeeObject = {
      operation: "APPROVERS",
    };
    return new Promise((resolve) => {
      this.http.post<IApprover[]>(
        this.apiUrl + "employees/",
        JSON.stringify(employeeObject)
      ).subscribe((response) => {
        resolve(response);
      }, (error) => {
        resolve(null);
      });
    });
  }

  setEmployee(employee): Promise<Array<IEmployee>> {
    employee.operation = "PUT";
    return new Promise((resolve) => {
      this.http.post(
        this.apiUrl + "employees/",
        JSON.stringify(employee)
      ).subscribe((response) => {
        for (let employeeKey in this.employees) {
          if (
            this.employees[employeeKey].employee_id === response[0].employee_id
          ) {
            this.employees[employeeKey] = response[0];
            break;
          }
        }
        resolve(response[0]);
      }, (error) => {
        resolve(null);
      });
    });
  }

  deleteEmployee(employee): Promise<Array<IEmployee>> {
    employee.operation = "DELETE";
    return new Promise((resolve) => {
      this.http.post<IEmployee[]>(
        this.apiUrl + "employees/",
        JSON.stringify(employee)
      ).subscribe((response) => {
        let foundIndex = this.employees.indexOf(employee);
        if (foundIndex > -1) {
          this.employees.splice(foundIndex, 1);
        }
        resolve(response);
      }, (error) => {
        resolve(null);
      });
    });
  }

  resetLoginEmployee(employee: IEmployee) {
    const employeeObject = {
      operation: "RESETLOGIN",
      first_name: employee.first_name,
      middle_name: employee.middle_name,
      last_name: employee.last_name,
      username: employee.username,
      email: employee.email,
      employee_id: employee.employee_id,
    };
    return new Promise((resolve) => {
      this.http
        .post(
          this.apiUrl + "employees/",
          JSON.stringify(employeeObject)
        ).subscribe((response) => {
          resolve(true);
        }, (error) => {
          resolve(null);
        });
    });
  }

  resetLogin(email: string) {
    const employeeObject = {
      operation: "LOGINRESET",
      email: email
    };
    return new Promise((resolve) => {
      this.http
        .post(
          this.apiUrl + "reset/",
          JSON.stringify(employeeObject)
        ).subscribe((response) => {
          resolve(response && !response['errorMessage']);
        }, (error) => {
          resolve(null);
        });
    });
  }

  setEmployeePassword(password) {
    const employeeObject = {
      operation: "SETPASSWORD",
      password,
      employee_id: this.loggedInEmployeeId,
    };
    return new Promise((resolve) => {
      this.http.post(
        this.apiUrl + "employees/",
        JSON.stringify(employeeObject)
      ).subscribe((response) => {
        resolve(true);
      }, (error) => {
        resolve(null);
      });
    });
  }

  filterEmployees(name: string): IEmployee[] {
    if (!this.employees) {
      return [];
    }
    return this.employees.filter((employee) => {
      return (
        employee.first_name.toLowerCase().indexOf(name.toLowerCase()) > -1 ||
        employee.last_name.toLowerCase().indexOf(name.toLowerCase()) > -1
      );
    });
  }

  saveRegistrationId(employeeId, registrationId) {
    let json = {
      employee_id: employeeId,
      registration_id: registrationId,
      operation: "PUT",
    };
    return new Promise((resolve) => {
      this.http.post(
        this.apiUrl + "notifications/",
        JSON.stringify(json)
      ).subscribe((response) => {
        //this.showToast('Registratie notificatie gelukt', 'short', 'bottom');
        resolve(true);
      }, (error) => {
        alert("Registratie notificatie mislukt " + JSON.stringify(error));
        resolve(false);
      });
    });
  }

  sendMessageToEmployee(employee_id: string, bodytext, titletext) {
    const employeeObject = {
      operation: "SENDMESSAGE",
      employee_id: employee_id,
      bodytext: bodytext,
      titletext: titletext,
    };
    return new Promise((resolve) => {
      this.http.post(
        this.apiUrl + "employees/",
        JSON.stringify(employeeObject)
      ).subscribe((response) => {
        resolve(true);
      }, (error) => {
        resolve(null);
      });
    });
  }

  /**
   * Helper method to make a unique clone of an object
   */
  cloneObject(obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.cloneObject(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = this.cloneObject(obj[attr]);
      }
      return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
  }
}



// WEBPACK FOOTER //
// ./src/providers/employee-data.ts